import { groupBy } from "./utilityHelper"
import ReadOnlyItemDataModel from "./models/ReadOnlyItem"
import ReadOnlyItem from "../appmodels/ReadOnlyItem"
import Category from './models/Category'

export const storageStateId = 5

export const removedStateId = 3

export const itemWithDeviceNameCategoryIds: ReadonlySet<number> = new Set([1, 5, 6, 7, 17,])

export const itemWithHostnameCategoryIds: ReadonlySet<number> = new Set([16,])

export const itemWithModelCategoryIds: ReadonlySet<number> = new Set([17,])

export const itemWithLampHoursCategoryIds: ReadonlySet<number> = new Set([3,])

export const itemWithIMEICategoryIds: ReadonlySet<number> = new Set([4,])

export const itemWithEnergyUsageCategoryIds: ReadonlySet<number> = new Set([16, /* 17, */])

export const itemWithFirmwareVersionCategoryIds: ReadonlySet<number> = new Set([18,])

export const itemWithNetworkSwitchCategoryIds: ReadonlySet<number> = new Set([17,])

export const toBeRemovedStateId = 7

export const rmaStateId = 2

export const takenOverByHRStateId = 8

export const rmaRoomId = 1094

export const noCategoryId = 0

export const beamerNavigationText = "Beamer"

export const numberRegexPattern = /^[\d]+$/

export const createReadOnlyItem = (item: ReadOnlyItemDataModel): ReadOnlyItem => ({
	id: item.Id,
	name: item.Name,
	inventoryNumber: item.InventoryNumber,
	stateId: item.StateId,
	state: item.State,
	categoryId: item.CategoryId,
	category: item.Category,
	deviceName: item.DeviceName,
	serialNumber: item.SerialNumber,
	imei: item.IMEI,
	room: item.Room,
	employee: item.Employee,
	lampHours: item.LampHours,
	comment: item.Comment,
	itemHistory: item.ItemHistory,
	hostname: item.Hostname,
	model: item.Model,
	firmwareVersion: item.FirmwareVersion,
	energyUsage: item.EnergyUsage,
	networkSwitchId: item.NetworkSwitchId,
	networkSwitch: item.NetworkSwitch,
})

type CategorizedItem = {
	Name: string
	CategoryId: number
}

export const CreateCategoryGroupedItemsShareText = (
	categories: readonly Category[],
	items: readonly CategorizedItem[]) =>
	`${[...groupBy(i => i.CategoryId, items)]
		.map(m => ({
			key: m[0],
			values: m[1]
		}))
		.map(m =>
			`${categories.find(f => f.Id === m.key)?.Name ?? "unkategorisiert"}:
			${m.values.map(i => i.Name).join("\n")}`)
		.join("\n\n")}`
